import { Component, Inject, Input, OnChanges, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { number } from "echarts";
import { ObjectUtil } from "../utils/ObjectUtil";
import { ThemeService } from "src/app/services/theme.service";

export interface Data {
  name: string;
  type: string;
  value?: any;
  child: Data[];
}

@Component({
    selector: "app-json-forms-popup",
    templateUrl: "./json-forms-popup.component.html",
    styleUrls: ["./json-forms-popup.component.scss"],
    standalone: false
})
export class JsonFormsPopupComponent implements OnInit, OnChanges {
  @Input() json: any;
  @Input() main: string = "main";
  //@Input() condition:string;
  data: Data[] = [];
  json_original = null;
  main2 = {};
  editing = false;
  loading = false;
  readonly jsonInit: string = JSON.parse(this.dialogData.json);
  constructor(
    public ThemeService:ThemeService,
    @Inject(MAT_DIALOG_DATA) public dialogData,
    public dialogRef: MatDialogRef<any>
  ) {}

  submit() {
    this.desMountJson(this.data, this.main2);
    this.dialogRef.close(this.main2);
  }

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {
    if (this.dialogData.json_original != null) {
      this.json_original = JSON.parse(this.dialogData.json_original);
    }

    this.json = JSON.parse(this.dialogData.json);
    this.main = this.dialogData.main;
    let main = { name: this.main, type: "main", child: [] };
    this.mountJson(this.json, main);
    this.data.push(main);
  }

  ngOnChanges() {
    this.editing = true;
  }

  ngDoCheck() {
  }

  recover() {
    this.loading = true;
    if (this.json_original != null) {
      this.json = this.json_original;
    } else {
      this.json = this.jsonInit;
    }
    this.data = [];
    let mainData = { name: this.main, type: "main", child: [] };
    setTimeout((call) => {
      this.mountJson(this.json, mainData);
      this.data.push(mainData);
      this.loading = false;
    }, 500);
  }

  desMountJson(ob: Data[], newData: Object) {
    if (ob instanceof Array) {
      ob.forEach((data: Data) => {
        if (data.child.length > 0) {
          if (data.type == "array") {
            newData[data.name] = [];
          } else {
            newData[data.name] = {};
          }
          this.desMountJson(data.child, newData[data.name]);
        } else {
          if (data.type == "number") {
            newData[data.name] = data.value as number;
          } else {
            if (data.type == "boolean") {
              newData[data.name] = data.value as boolean;
            } else {
              if (data.type == "string" || data.type == "null") {
                newData[data.name] = data.value as string;
              } else {
                if (data.type == "array") {
                  newData[data.name] = [];
                } else {
                  if (data.type == "object") {
                    newData[data.name] = {};
                  }
                }
              }
            }
          }
        }
      });
    }
  }

  mountJson(ob: any, newData: Data) {
    if (ob instanceof Object) {
      Object.keys(ob).forEach((key) => {
        let tipo: string = typeof ob[key];
        let value = ob[key];

        if ("number,boolean,string".indexOf(tipo) > -1 || value == null) {
          if (value == null) {
            tipo = "null";
          }
          let dateCreate: Data = {
            name: key,
            type: tipo,
            value: value,
            child: [],
          };

          newData.child.push(dateCreate);
        } else {
          if (ob[key] instanceof Object) {
            tipo = "object";
          }

          if (ob[key] instanceof Array) {
            tipo = "array";
          }

          let xNewData = {
            name: key,
            type: tipo,
            //value: ob[key],
            child: [],
          };
          this.mountJson(ob[key], xNewData);

          newData.child.push(xNewData);
        }
      });
    }
  }

  toNumber(value) {
    return Number.parseInt(value);
  }

  isNumber(value) {
    return ObjectUtil.isNumber(value);
  }
}
